import React, { lazy } from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Grace M.',
    role: 'Pilates Instructor — London, UK',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80',
    text: 'Preparation time was my biggest stress. With this 6-in-1 system, I reclaimed my social life. The sequences flow and my students love the variety.'
  }, {
    name: 'Sarah L.',
    role: 'Studio Owner — New York, USA',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80',
    text: "The Cueing Dictionary and the Transition Bible saved my life. The pack is worth 10 times its price; it's a total game-changer for my studio."
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-212">
      <div className="max-w-5xl mx-auto" data-id="element-213">
        <div className="text-center mb-12" data-id="element-214">
          <div className="bg-pilates-lavender/25 text-pilates-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-215">
            What your colleagues are saying
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-216">
            Testimonials from{' '}
            <span className="italic text-pilates-sage-dark" data-id="element-217">professionals</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-218">
          {testimonials.map((t, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 shadow-sm border border-pilates-sage/15 flex flex-col" data-id="element-219">
              <div className="flex text-pilates-rose mb-4" data-id="element-220">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-221" />)}
              </div>
              <p className="text-pilates-slate leading-relaxed mb-6 italic flex-1 text-base" data-id="element-222">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-pilates-sage/20" data-id="element-223">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover" loading="lazy" decoding="async" width="48" height="48" data-id="element-224" />
                <div data-id="element-225">
                  <p className="font-display font-semibold text-pilates-dark text-base" data-id="element-226">
                    {t.name}
                  </p>
                  <p className="text-pilates-slate text-xs" data-id="element-227">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}